import React, { Component } from 'react';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { Link } from 'react-router-dom';
import SearchBar from '../SearchBar';
import FormControl from 'react-bootstrap/lib/FormControl';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import { connect } from 'react-redux';
import { fetchUser, fetchUserRoles } from '../../actions/authentificationActions';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import { Left } from 'react-bootstrap/lib/Media';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import '../../css/style.css';
import { NotificationOutlined, HistoryOutlined } from '@ant-design/icons';
import AtmeLists from './AtmeLists.js';
import HistoryUpdate from './HistoryUpdate.js';
import { Badge } from 'antd';
import { Tooltip } from 'antd';
import { Popover } from 'antd';

const cookies = new Cookies();
var token = cookies.get('token');

const mapStoreToProps = (store) => {
    return {
        user: store.authentification.user,
    };
};

class Header extends Component {

    deadlineAlertsLoading = false;
    deadlineAlertsLoaded = false;

    state = {
        keyword: '',
        SearchCheckbox: 0,
        roles: [],
        message_count: 0,
        message_count_invoice: 0,
        message_count_order: 0,
        message_count_backorder: 0,
        message_count_inquirie: 0,
        message_client_count_inquirie: 0,
        atme_message_count: 0,
        pending_deadline_soon_count: 0,
        pending_deadline_overdue_count: 0,
        atme_deadline_soon_count: 0,
        atme_deadline_overdue_count: 0,

        update_message_count: window.history_update_items.length,
        red_dot_update: false,
    }

    componentWillMount() {
        this.props.dispatch(fetchUser());
        this.fetchRoles();

        if (localStorage.getItem('search_sort')) {
            this.setState({
                SearchCheckbox: parseInt(localStorage.getItem('search_sort'))
            })
        }

        let red_dot_update = false;
        let localStorage_red_dot_update = localStorage.getItem('update_message_count');
        if (localStorage_red_dot_update == 'undefined') {
            localStorage_red_dot_update = 0;
        }
        if (this.state.update_message_count > localStorage_red_dot_update) {
            red_dot_update = true;
        }
        console.log(this.state.update_message_count)
        console.log(localStorage_red_dot_update)
        this.setState({
            red_dot_update: red_dot_update
        });
    }

    fetchRoles = () => {
        axios.get(window.api + 'admin/findRoles?token=' + token)
            .then((response) => {
                this.setState({
                    roles: response.data.data.permissions,
                    message_count: response.data.data.message_count,
                    message_count_invoice: response.data.data.message_count_invoice,
                    message_count_order: response.data.data.message_count_order,
                    message_count_backorder: response.data.data.message_count_backorder,
                    atme_message_count: response.data.data.atme_message_count,
                    message_count_inquirie: response.data.data.message_count_inquirie,
                    message_client_count_inquirie: response.data.data.message_client_count_inquirie,
                });
                localStorage.setItem('permissions', JSON.stringify(response.data.data.permissions))
                localStorage.setItem('message_count', response.data.data.message_count)
                localStorage.setItem('message_count_invoice', response.data.data.message_count_invoice)
                localStorage.setItem('message_count_order', response.data.data.message_count_order)
                localStorage.setItem('message_count_backorder', response.data.data.message_count_backorder)
                localStorage.setItem('message_count_inquirie', response.data.data.message_count_inquirie)
                localStorage.setItem('message_client_count_inquirie', response.data.data.message_client_count_inquirie)
                localStorage.setItem('half_work', response.data.data.half_work)
                if (!localStorage.getItem('atme_message_count')) {
                    localStorage.setItem('atme_message_count', response.data.data.atme_message_count)
                    // console.log('更新atme_message_count:');
                    // console.log(localStorage.getItem('atme_message_count'));
                }
                this.fetchDeadlineAlerts();
            })
            .catch((error) => {
            })
    }

    fetchDeadlineAlerts = async () => {
        if (this.deadlineAlertsLoading || this.deadlineAlertsLoaded) {
            return;
        }
        this.deadlineAlertsLoading = true;
        try {
            const response = await axios.get(window.api + 'admin/fetchAtmeDeadlineSummary?token=' + token);
            const summary = response?.data?.data || {};
            const toCount = (...values) => {
                for (let i = 0; i < values.length; i += 1) {
                    const parsed = parseInt(values[i], 10);
                    if (!Number.isNaN(parsed)) {
                        return parsed;
                    }
                }
                return 0;
            };

            const pendingSoon = toCount(
                summary.pending_deadline_soon_count,
                summary.pending_soon_count,
                summary.initiated_deadline_soon_count,
                summary.initiated_soon_count,
                summary.noread_deadline_soon_count,
                summary.noread_soon_count,
                summary.pending?.deadline_soon_count,
                summary.pending?.soon_count,
                summary.initiated?.deadline_soon_count,
                summary.initiated?.soon_count,
            );
            const pendingOverdue = toCount(
                summary.pending_deadline_overdue_count,
                summary.pending_overdue_count,
                summary.initiated_deadline_overdue_count,
                summary.initiated_overdue_count,
                summary.noread_deadline_overdue_count,
                summary.noread_overdue_count,
                summary.pending?.deadline_overdue_count,
                summary.pending?.overdue_count,
                summary.initiated?.deadline_overdue_count,
                summary.initiated?.overdue_count,
            );
            const atmeSoon = toCount(
                summary.atme_deadline_soon_count,
                summary.atme_soon_count,
                summary.mention_deadline_soon_count,
                summary.mention_soon_count,
                summary.atme?.deadline_soon_count,
                summary.atme?.soon_count,
                summary.mention?.deadline_soon_count,
                summary.mention?.soon_count,
                summary.deadline_soon_count,
                summary.soon_count,
            );
            const atmeOverdue = toCount(
                summary.atme_deadline_overdue_count,
                summary.atme_overdue_count,
                summary.mention_deadline_overdue_count,
                summary.mention_overdue_count,
                summary.atme?.deadline_overdue_count,
                summary.atme?.overdue_count,
                summary.mention?.deadline_overdue_count,
                summary.mention?.overdue_count,
                summary.deadline_overdue_count,
                summary.overdue_count,
            );

            this.setState({
                pending_deadline_soon_count: pendingSoon,
                pending_deadline_overdue_count: pendingOverdue,
                atme_deadline_soon_count: atmeSoon,
                atme_deadline_overdue_count: atmeOverdue,
            });
        } catch (error) {
        } finally {
            this.deadlineAlertsLoaded = true;
            this.deadlineAlertsLoading = false;
        }
    }

    setLocal = (locale) => {
        localStorage.setItem('locale', locale);
        window.location.reload();
    }

    changeSearchBarStatus = () => {
        this.state.showSearchBar ? this.setState({ showSearchBar: false }) : this.setState({ showSearchBar: true });
    }

    Search = (event) => {
        this.setState({ keyword: event.target.value });
    }

    SearchCheckbox = (event) => {
        var value = event.target.checked ? 1 : 0;
        this.setState({ SearchCheckbox: value });
        localStorage.setItem('search_sort', value);
    }

    onRef = (ref) => {
        this.childAtmeLists = ref
    }

    showAtme = () => {
        this.childAtmeLists.showModal();
    }

    showHistoryUpdate = () => {
        localStorage.setItem('update_message_count', this.state.update_message_count);
        this.setState({
            red_dot_update: false
        });
        this.childHistoryUpdate.showModal();
    }

    render() {

        const { user } = this.props;

        let permissions = [];
        // let roles = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : this.state.roles;

        let roles = this.state.roles;
        if (localStorage.getItem('permissions') && localStorage.getItem('permissions') != 'undefined') {
            roles = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : this.state.roles;
        }

        if (roles) {
            roles.map(option => {
                permissions[option] = true;
            });
        }

        let message_count = localStorage.getItem('message_count') ? localStorage.getItem('message_count') : this.state.message_count;
        let message_count_invoice = localStorage.getItem('message_count_invoice') ? localStorage.getItem('message_count_invoice') : this.state.message_count_invoice;
        let message_count_order = localStorage.getItem('message_count_order') ? localStorage.getItem('message_count_order') : this.state.message_count_order;
        let message_count_backorder = localStorage.getItem('message_count_backorder') ? localStorage.getItem('message_count_backorder') : this.state.message_count_backorder;
        let message_count_inquirie = localStorage.getItem('message_count_inquirie') ? localStorage.getItem('message_count_inquirie') : this.state.message_count_inquirie;
        let message_client_count_inquirie = localStorage.getItem('message_client_count_inquirie') ? localStorage.getItem('message_client_count_inquirie') : this.state.message_client_count_inquirie;
        let message_count_inquiries = parseInt(message_client_count_inquirie) + parseInt(message_count_inquirie);

        let red_tips = false;
        if (this.state.atme_message_count > localStorage.getItem('atme_message_count')) {
            red_tips = true;
        }
        const pendingDeadlineCount = this.state.pending_deadline_soon_count + this.state.pending_deadline_overdue_count;
        const atmeDeadlineCount = this.state.atme_deadline_soon_count + this.state.atme_deadline_overdue_count;
        const deadlineReminderCount = pendingDeadlineCount + atmeDeadlineCount;
        const formatBadgeCount = (count) => (count > 99 ? '99+' : `${count}`);
        const splitDeadlineCountText = `${formatBadgeCount(pendingDeadlineCount)}/${formatBadgeCount(atmeDeadlineCount)}`;
        const deadlineReminderPopoverContent = (
            <div style={{ minWidth: '250px' }}>
                <div style={{ fontSize: '12px', fontWeight: 600, marginBottom: '8px' }}>截止提醒明细</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '12px' }}>
                    <span>发起待处理</span>
                    <span>
                        <span style={{ color: '#faad14' }}>即将 {this.state.pending_deadline_soon_count}</span>
                        <span style={{ color: '#d9d9d9' }}> · </span>
                        <span style={{ color: '#ff4d4f' }}>已过期 {this.state.pending_deadline_overdue_count}</span>
                    </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                    <span>@我</span>
                    <span>
                        <span style={{ color: '#faad14' }}>即将 {this.state.atme_deadline_soon_count}</span>
                        <span style={{ color: '#d9d9d9' }}> · </span>
                        <span style={{ color: '#ff4d4f' }}>已过期 {this.state.atme_deadline_overdue_count}</span>
                    </span>
                </div>
            </div>
        );

        let inquiryNav = (
            <>
                {permissions[11000] ?
                    <NavDropdown eventKey={8} title={
                        <>
                            询价
                            {message_count_inquiries > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_inquiries}</span> : null}
                        </>
                    } id="basic-nav-dropdown">
                        {permissions[1101] ? <MenuItem eventKey={8.1} href="/inquiries">询价列表
                            {message_count_inquirie > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_inquirie}</span> : null}
                        </MenuItem> : null}
                        {permissions[1103] ? <MenuItem eventKey={8.3} href="/members">询价成员</MenuItem> : null}
                        {/* {permissions[1108] ? <MenuItem eventKey={8.8} href="/client_inquiries">我的询价
                        {message_client_count_inquirie > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_client_count_inquirie}</span> : null}
                        </MenuItem> : null} */}
                        {permissions[1104] ? <MenuItem eventKey={8.4} href="/prices">价格表</MenuItem> : null}
                        {permissions[1105] ? <MenuItem eventKey={8.5} href="/discounts">折扣表</MenuItem> : null}
                        {permissions[1106] ? <MenuItem eventKey={8.6} href="/refs">关联折扣</MenuItem> : null}
                        {permissions[1107] ? <MenuItem eventKey={8.7} href="/analysis">批量分析</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let orderNav = (
            <>
                {permissions[1000] ?
                    <NavDropdown eventKey={2} title={
                        <>
                            {React.Component.prototype.$intl.get("订单")}
                            {(parseInt(message_count_order) + parseInt(message_count_backorder)) > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{parseInt(message_count_order) + parseInt(message_count_backorder)}</span> : null}
                        </>
                    } id="basic-nav-dropdown">
                        {permissions[1] ? <MenuItem eventKey={2.1} href="/orders">{React.Component.prototype.$intl.get('订单列表')}
                            {message_count_order > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_order}</span> : null}
                        </MenuItem> : null}
                        {permissions[2] ? <MenuItem eventKey={2.2} href="/order/create">{React.Component.prototype.$intl.get('添加订单')}</MenuItem> : null}
                        {(user.client < 1 && permissions[3]) ? <MenuItem eventKey={2.3} href="/storage">{React.Component.prototype.$intl.get('订单到货')}</MenuItem> : null}
                        {(user.client < 1 && permissions[4]) ? <MenuItem eventKey={2.4} href="/delivery">{React.Component.prototype.$intl.get('到货统计')}</MenuItem> : null}
                        {(user.client < 1 && permissions[5]) ? <MenuItem eventKey={2.5} href="/StorageOverview">到货情况</MenuItem> : null}
                        {(user.client < 1 && permissions[12]) ? <Tooltip mouseEnterDelay={0} mouseLeaveDelay={0} placement='left' title="查看出项账单和进项账单不在同月的产品"><MenuItem eventKey={2.51} href="/inventory">存货列表</MenuItem></Tooltip> : null}
                        {(user.client < 1 && permissions[6]) ? <MenuItem eventKey={2.6} href="/ztns">品名管理</MenuItem> : null}
                        {(user.client < 1 && permissions[13]) ? <MenuItem eventKey={2.91} href="/tariffnumbers">税号管理</MenuItem> : null}
                        {(user.client < 1 && permissions[6]) ? <MenuItem eventKey={2.7} href="/hscodes">原产地管理</MenuItem> : null}
                        {(user.client < 1 && permissions[9]) ? <MenuItem eventKey={2.8} href="/back/orders">退回订单
                            {message_count_backorder > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_backorder}</span> : null}
                        </MenuItem> : null}
                        {(user.client < 1 && permissions[10]) ? <MenuItem eventKey={2.9} href="/back/order/create">添加退回订单</MenuItem> : null}
                        {permissions[11] ? <MenuItem eventKey={2.10} href="/order/stocks">库存管理</MenuItem> : null}
                        {permissions[15] ? <MenuItem eventKey={2.11} href="/order/gutschrift">Gutschrift列表</MenuItem> : null}
                        {permissions[14] ? <MenuItem eventKey={2.12} href="/order/short-products">少货列表</MenuItem> : null}
                        {permissions[16] ? <MenuItem eventKey={2.13} href="/pickups">取货物流</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let warehouseOrderNav = (
            <>
                {permissions[1000] ?
                    <NavDropdown eventKey={2} title={
                        <>
                            {React.Component.prototype.$intl.get("订单")}
                            {(parseInt(message_count_order) + parseInt(message_count_backorder)) > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{parseInt(message_count_order) + parseInt(message_count_backorder)}</span> : null}
                        </>
                    } id="basic-nav-dropdown">
                        {permissions[1] ? <MenuItem eventKey={2.1} href="/orders">{React.Component.prototype.$intl.get('订单列表')}</MenuItem> : null}
                        {permissions[2] ? <MenuItem eventKey={2.2} href="/order/create">{React.Component.prototype.$intl.get('添加订单')}</MenuItem> : null}
                        {(user.client < 1 && permissions[3]) ? <MenuItem eventKey={2.3} href="/storage">{React.Component.prototype.$intl.get('订单到货')}</MenuItem> : null}
                        {(user.client < 1 && permissions[4]) ? <MenuItem eventKey={2.4} href="/delivery">{React.Component.prototype.$intl.get('到货统计')}</MenuItem> : null}
                        {(user.client < 1 && permissions[5]) ? <MenuItem eventKey={2.5} href="/StorageOverview">到货情况</MenuItem> : null}
                        {(user.client < 1 && permissions[12]) ? <Tooltip mouseEnterDelay={0} mouseLeaveDelay={0} placement='left' title="查看出项账单和进项账单不在同月的产品"><MenuItem eventKey={2.51} href="/inventory">存货列表</MenuItem></Tooltip> : null}
                        {(user.client < 1 && permissions[6]) ? <MenuItem eventKey={2.6} href="/ztns">品名管理</MenuItem> : null}
                        {(user.client < 1 && permissions[13]) ? <MenuItem eventKey={2.91} href="/tariffnumbers">税号管理</MenuItem> : null}
                        {(user.client < 1 && permissions[6]) ? <MenuItem eventKey={2.7} href="/hscodes">原产地管理</MenuItem> : null}
                        {(user.client < 1 && permissions[9]) ? <MenuItem eventKey={2.8} href="/back/orders">退回订单
                            {message_count_backorder > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_backorder}</span> : null}
                        </MenuItem> : null}
                        {permissions[10] ? <MenuItem eventKey={2.9} href="/back/order/create">添加退回订单</MenuItem> : null}
                        {permissions[11] ? <MenuItem eventKey={2.10} href="/order/stocks">库存管理</MenuItem> : null}
                        {permissions[15] ? <MenuItem eventKey={2.11} href="/order/gutschrift">Gutschrift列表</MenuItem> : null}
                        {permissions[14] ? <MenuItem eventKey={2.12} href="/order/short-products">少货列表</MenuItem> : null}
                        {permissions[16] ? <MenuItem eventKey={2.13} href="/pickups">取货物流</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let brandNav = (
            <>
                {permissions[2000] ?
                    <NavDropdown eventKey={3} title={React.Component.prototype.$intl.get("品牌")} id="basic-nav-dropdown">
                        {permissions[101] ? <MenuItem eventKey={3.1} href="/brands">{React.Component.prototype.$intl.get('品牌列表')}</MenuItem> : null}
                        {permissions[102] ? <MenuItem eventKey={3.2} href="/brand/create">{React.Component.prototype.$intl.get('添加品牌')}</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let resourceNav = (
            <>
                {permissions[3000] ?
                    <NavDropdown eventKey={4} title={React.Component.prototype.$intl.get("渠道")} id="basic-nav-dropdown">
                        {permissions[201] ? <MenuItem eventKey={4.1} href="/resources">{React.Component.prototype.$intl.get('渠道列表')}</MenuItem> : null}
                        {permissions[202] ? <MenuItem eventKey={4.2} href="/resource/create">{React.Component.prototype.$intl.get('添加渠道')}</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let clientNav = (
            <>
                {permissions[4000] ?
                    <NavDropdown eventKey={5} title={React.Component.prototype.$intl.get("客户")} id="basic-nav-dropdown">
                        {permissions[301] ? <MenuItem eventKey={5.1} href="/clients">{React.Component.prototype.$intl.get('客户列表')}</MenuItem> : null}
                        {permissions[302] ? <MenuItem eventKey={5.2} href="/client/create">{React.Component.prototype.$intl.get('添加客户')}</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let buyNav = (
            <>
                {permissions[7000] ?
                    <NavDropdown eventKey={5} title={'采购公司'} id="basic-nav-dropdown">
                        {permissions[701] ? <MenuItem eventKey={70.1} href="/buys">公司列表</MenuItem> : null}
                        {permissions[702] ? <MenuItem eventKey={70.2} href="/buy/create">添加公司</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let invoiceNav = (
            <>
                {permissions[5000] ?
                    <NavDropdown eventKey={6} title={
                        <>
                            {React.Component.prototype.$intl.get("帐单")}
                            {message_count_invoice > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_invoice}</span> : null}
                        </>
                    } id="basic-nav-dropdown">
                        {permissions[401] ? <MenuItem eventKey={6.1} href="/invoices">{React.Component.prototype.$intl.get('帐单列表')}{message_count_invoice > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count_invoice}</span> : null}</MenuItem> : null}
                        {permissions[402] ? <MenuItem eventKey={6.2} href="/invoice/create">{React.Component.prototype.$intl.get('添加帐单')}</MenuItem> : null}
                        {permissions[403] ? <MenuItem eventKey={6.3} href="/payments">收到账单列表</MenuItem> : null}
                        {permissions[403] ? <MenuItem eventKey={6.31} href="/auto-invoices">收到账单(AI)</MenuItem> : null}
                        {permissions[404] ? <MenuItem eventKey={6.4} href="/payment/create">创建收到账单</MenuItem> : null}
                        {permissions[404] ? <MenuItem eventKey={6.5} href="/paymentProformas">预付账单管理</MenuItem> : null}
                        {permissions[404] ? <MenuItem eventKey={6.6} href="/incomes">收款管理</MenuItem> : null}
                        {permissions[404] ? <MenuItem eventKey={6.7} href="/income/create">创建收款</MenuItem> : null}
                        {permissions[404] ? <MenuItem eventKey={6.9} href="/invoice/delivery">账单到货</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let warehouseInvoiceNav = (
            <>
                {permissions[5000] ?
                    <NavDropdown eventKey={6} title={React.Component.prototype.$intl.get("帐单")} id="basic-nav-dropdown">
                        {permissions[401] ? <MenuItem eventKey={6.1} href="/invoices">{React.Component.prototype.$intl.get('帐单列表')}</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let waybillNav = (
            <>
                {permissions[8000] ?
                    <NavDropdown eventKey={12} title={"箱单"} id="basic-nav-dropdown">
                        {permissions[801] ? <MenuItem eventKey={12.1} href="/waybills">箱单列表</MenuItem> : null}
                        {permissions[802] ? <MenuItem eventKey={12.2} href="/waybill/create">创建箱单</MenuItem> : null}
                        {permissions[803] ? <MenuItem eventKey={12.3} href="/tors">托盘管理</MenuItem> : null}
                        {/* {permissions[803] ? <MenuItem eventKey={12.3} href="/sticker/create">创建贴纸</MenuItem> : null} */}
                    </NavDropdown>
                    : null}
            </>
        );

        let contractNav = (
            <>
                {permissions[6000] ?
                    <NavDropdown eventKey={7} title={React.Component.prototype.$intl.get("合同")} id="basic-nav-dropdown">
                        {permissions[501] ? <MenuItem eventKey={7.1} href="/contracts">{React.Component.prototype.$intl.get('合同列表')}</MenuItem> : null}
                        {permissions[502] ? <MenuItem eventKey={7.2} href="/contract/create">{React.Component.prototype.$intl.get('添加合同')}</MenuItem> : null}
                        {permissions[503] ? <MenuItem eventKey={7.3} href="/contract/analysis">{React.Component.prototype.$intl.get('业绩分析')}</MenuItem> : null}
                        {permissions[501] ? <MenuItem eventKey={7.4} href="/transfers">其他汇款</MenuItem> : null}
                        {permissions[501] ? <MenuItem eventKey={7.4} href="/transfer/create">添加汇款</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </>
        );

        let searchNav = (
            <>
                {permissions[601] ?
                    <ul className="nav navbar-nav navbar-right aoi-header-search-nav">
                        <li role="presentation" className="aoi-header-search-item" onClick={this.changeSearchBarStatus.bind(this)}>
                            <FormControl style={{ height: "30px", borderRadius: "4px", marginTop: "5px", marginLeft: "5px", float: "left", marginRight: "5px", width: "170px" }} size="sm" type="text" placeholder="Search Here..." onChange={this.Search.bind(this)} maxLength='50' value={this.state.keyword} />
                            <Checkbox style={{ marginTop: "10px" }} onChange={this.SearchCheckbox.bind(this)} value={this.state.SearchCheckbox} defaultChecked={this.state.SearchCheckbox} inline>{React.Component.prototype.$intl.get('最新')}</Checkbox>
                        </li>
                    </ul>
                    : null}
            </>
        );

        let nav = (
            <Nav>
                {/* <NavItem eventKey={1} href="/">{React.Component.prototype.$intl.get("首页")}</NavItem> */}
                {inquiryNav}
                {orderNav}
                {brandNav}
                {(user.client < 1 || user.client) ? resourceNav : null}
                {(user.client < 1) ? clientNav : null}
                {(user.client < 1) ? invoiceNav : null}
                {(user.client < 1) ? contractNav : null}
                {waybillNav}

                {permissions[602] ? <MenuItem eventKey={13.1} href="/todolist">留言{message_count > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count}</span> : null}</MenuItem> : null}
                {permissions[9000] ?
                    <NavDropdown eventKey={14} title={"货运"} id="basic-nav-dropdown">
                        {permissions[901] ? <MenuItem eventKey={14.1} href="/freights">货运列表</MenuItem> : null}
                        {permissions[902] ? <MenuItem eventKey={14.2} href="/freight/create">创建货运</MenuItem> : null}
                    </NavDropdown>
                    : null}
                {buyNav}
            </Nav>
        );

        // 仓库角色菜单
        let warehouseNav = (
            <Nav>
                <NavItem eventKey={1} href="/">{React.Component.prototype.$intl.get('首页')}</NavItem>
                {warehouseOrderNav}
                {(user.client < 1) ? warehouseInvoiceNav : null}
                {waybillNav}
                <MenuItem eventKey={13.1} href="/todolist">留言{message_count > 0 ? <span style={{ fontSize: '18px', color: '#FFF' }}>{message_count}</span> : null}</MenuItem>
                {permissions[9000] ?
                    <NavDropdown eventKey={14} title={"货运"} id="basic-nav-dropdown">
                        {permissions[901] ? <MenuItem eventKey={14.1} href="/freights">货运列表</MenuItem> : null}
                        {permissions[902] ? <MenuItem eventKey={14.2} href="/freight/create">创建货运</MenuItem> : null}
                    </NavDropdown>
                    : null}
            </Nav>
        );
        // console.log(window.location.host);
        return (
            <div>
                <Navbar collapseOnSelect className='aoi_header'>
                    <Navbar.Header>
                        <Navbar.Brand>
                            <a href="/" style={{ fontSize: '14px' }}>
                                {/* AOI Order System */}
                                {window.location.host == 'demo.aoioffice.com' ?
                                    <img style={{ height: '43px', display: 'inline-block', marginTop: '-12px' }} src={window.location.protocol + "//" + window.location.host + "/AOIOfficedemo.png"} />
                                    :
                                    <img style={{ height: '43px', display: 'inline-block', marginTop: '-12px' }} src={window.location.protocol + "//" + window.location.host + "/AOIOffice.png?v=2"} />
                                }
                            </a>
                        </Navbar.Brand>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    {
                        user ?
                            <Navbar.Collapse>

                                {/* {(user.group && user.group !== 4 && user.group !== 9) ? nav : null}
                                {(user.group && user.group == 9) ? warehouseNav : null} */}
                                {(user.group && user.group !== 4) ? nav : null}

                                {permissions[10000] ?
                                    <Nav>
                                        <NavDropdown eventKey={16} title={"运营"} id="basic-nav-dropdown">
                                            {permissions[1001] ? <MenuItem eventKey={16.1} href="/report/logistics">物流</MenuItem> : null}
                                            {permissions[1002] ? <MenuItem eventKey={16.2} href="/report/logistic/create">添加物流支出</MenuItem> : null}
                                            {permissions[1003] ? <MenuItem eventKey={16.3} href="/report/offices">办公室</MenuItem> : null}
                                            {permissions[1004] ? <MenuItem eventKey={16.4} href="/report/office/create">添加办公室支出</MenuItem> : null}
                                            {permissions[1005] ? <MenuItem eventKey={16.5} href="/report/vacations">休假计划</MenuItem> : null}
                                            {permissions[1006] ? <MenuItem eventKey={16.6} href="/report/vacation/create">添加休假</MenuItem> : null}
                                            {permissions[1007] ? <MenuItem eventKey={16.7} href="/wikis">wiki文档</MenuItem> : null}
                                            {permissions[1008] ? <MenuItem eventKey={19} href="/wiki/create">添加wiki</MenuItem> : null}

                                            <MenuItem eventKey={16.9} href="/tools/translate">邮件AI翻译</MenuItem>
                                            {/* <MenuItem eventKey={16.10} href="/pdf_extracts">PDF解析型号</MenuItem> */}
                                            {permissions[1009] ? <MenuItem eventKey={17.1} href="/report/worktime">工作时间</MenuItem> : null}

                                        </NavDropdown>
                                    </Nav>
                                    : null}

                                {permissions[602] ?
                                    <Nav pullLeft>
                                        <NavItem eventKey={15.1} onClick={this.showAtme}>
                                            <Popover
                                                trigger="hover"
                                                placement="bottomRight"
                                                content={deadlineReminderPopoverContent}
                                            >
                                                <span>
                                                    <NotificationOutlined style={{ color: deadlineReminderCount > 0 ? '#ff7875' : undefined }} />
                                                    {deadlineReminderCount > 0 ?
                                                        <Badge count={splitDeadlineCountText} size="small"></Badge>
                                                        :
                                                        <Badge count={red_tips ? 1 : 0} dot></Badge>
                                                    }
                                                    </span>
                                            </Popover>
                                        </NavItem>
                                    </Nav>
                                    : null}

                                <Nav pullLeft>
                                    <Tooltip title='更新日志'>
                                        <NavItem eventKey={15.2} onClick={this.showHistoryUpdate.bind(this)}>
                                            <HistoryOutlined />
                                            <Badge count={this.state.red_dot_update ? 1 : 0} dot></Badge>
                                        </NavItem>
                                    </Tooltip>
                                </Nav>

                                <Nav pullRight>
                                    <NavDropdown eventKey={11} title={user.name} id="basic-nav-dropdown" style={{ maxWidth: "80px", whiteSpace: 'nowrap' }}>
                                        <MenuItem eventKey={11.1} href="/User">{React.Component.prototype.$intl.get('修改密码')}</MenuItem>
                                        <MenuItem eventKey={11.5} href="/UserSecurity">{React.Component.prototype.$intl.get('登录安全设置')}</MenuItem>
                                        <MenuItem eventKey={11.4} target='_blank' href={`${window.api}user/card/cn?token=${token}`}>我的名片</MenuItem>
                                        {(user.role == 'permission' || user.role == 'admin') ?
                                            <>
                                                <MenuItem eventKey={11.3} href="/admin/permissions">团队管理</MenuItem>
                                            </> : null
                                        }
                                        <MenuItem eventKey={11.2} href="/logout">{React.Component.prototype.$intl.get('退出')}</MenuItem>
                                        <NavDropdown eventKey={10} title={localStorage.getItem('locale')} id="basic-nav-dropdown">
                                            <MenuItem eventKey={10.1} onClick={this.setLocal.bind(this, 'zh-cn')}>zh-cn</MenuItem>
                                            <MenuItem eventKey={10.2} onClick={this.setLocal.bind(this, 'de')}>de</MenuItem>
                                            <MenuItem eventKey={10.3} onClick={this.setLocal.bind(this, 'en')}>en</MenuItem>
                                        </NavDropdown>
                                    </NavDropdown>
                                </Nav>

                                {(user.client < 1) ? searchNav : null}
                            </Navbar.Collapse>
                            : null
                    }

                </Navbar>
                <div className="container"><SearchBar keyword={this.state.keyword} SearchCheckbox={this.state.SearchCheckbox} /></div>

                <AtmeLists atme_message_count={this.state.atme_message_count} onRef={this.onRef} fetchRoles={() => {
                    this.fetchRoles();
                }} />

                <HistoryUpdate update_message_count={this.state.update_message_count} onRef={(ref) => {
                    this.childHistoryUpdate = ref
                }} items={window.history_update_items} />
            </div>
        );
    }

}

export default connect(mapStoreToProps)(Header);
